<template>
    <div
        class="weeduc-admin-page weflix-personalize-admin text-start p-0"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    title="Personalizar"
                    subtitle="Ajuste informações, visual, redes e integrações do site Weflix."
                    :hasMargin="false"
                />
            </div>
            <div class="weeduc-admin-page__header-actions">
                <button type="button" class="btn btn-block btn-content" @click="fillPreviewData">
                    Preencher dados
                </button>
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <nav class="weeduc-admin-tabs" aria-label="Seções de personalização">
                    <button
                        v-for="tab in personalizeTabs"
                        :key="tab.id"
                        type="button"
                        class="weeduc-admin-tab"
                        :class="{ 'weeduc-admin-tab--active': activeTab === tab.id }"
                        @click="setActiveTab(tab.id)"
                    >
                        {{ tab.label }}
                    </button>
                </nav>

                <div class="weeduc-admin-site-panels">
                    <section
                        v-show="isActiveTab(1)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(1) }"
                    >
                        <Basic ref="basic" />
                    </section>
                    <section
                        v-show="isActiveTab(3)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(3) }"
                    >
                        <Themes ref="themes" />
                    </section>
                    <section
                        v-show="isActiveTab(2)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(2) }"
                    >
                        <LayoutEditor ref="layoutEditor" />
                    </section>
                    <section
                        v-show="isActiveTab(4)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(4) }"
                    >
                        <SocialMedia ref="socialMedia" />
                    </section>
                    <section
                        v-show="isActiveTab(6)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(6) }"
                    >
                        <Integrations ref="integrations" />
                    </section>
                    <section
                        v-show="isActiveTab(5)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(5) }"
                    >
                        <Advanced ref="advanced" />
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Basic from '@/components/Weflix/Layout/basic.vue';
    import Advanced from '@/components/Weflix/Layout/advanced.vue';
    import Integrations from '@/components/Weflix/Layout/integrations.vue';
    import LayoutEditor from '@/components/Weflix/Layout/layout.vue';
    import Themes from '@/components/Weflix/Layout/themes.vue';
    import SocialMedia from '@/components/Weflix/Layout/socialMedia.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        data() {
            return {
                activeTab: 1,
                hassaved: false,
                openmodalmodule: false,
            };
        },
        components: {
            Basic,
            Advanced,
            Integrations,
            LayoutEditor,
            Themes,
            SocialMedia,
            TitlePage,
        },
        computed: {
            personalizeTabs() {
                return [
                    { id: 1, label: 'Básico' },
                    { id: 3, label: 'Temas' },
                    { id: 2, label: 'Layout' },
                    { id: 4, label: 'Redes sociais' },
                    { id: 6, label: 'Integrações' },
                    { id: 5, label: 'Avançado' },
                ];
            },
        },
        methods: {
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
            fillPreviewData() {
                this.$refs.basic?.fillPreviewData?.();
                this.$refs.themes?.fillPreviewData?.();
                this.$refs.layoutEditor?.fillPreviewData?.();
                this.$refs.socialMedia?.fillPreviewData?.();
                this.$refs.integrations?.fillPreviewData?.();
                this.$refs.advanced?.fillPreviewData?.();
            },
        },
    };
</script>

<style scoped>
    @import url('@/css/weeduc/admin/dashboard-weflix-shell.css');

    .weeduc-admin-site-panels {
        min-height: 200px;
    }

    .weeduc-admin-site-section {
        display: block;
    }

    :global(.dashboard.dark) .weeduc-admin-page :deep(.v-btn.bg-primary) {
        background: #e8eaf0 !important;
        color: #1a1d24 !important;
    }
</style>
